export default "__VITE_ASSET__CWvSPQuz__"